<template>
  <v-container class="pa-0">

     <v-col class="d-flex justify-end pt-3 pb-0 px-0" cols="12">
      <v-btn
        color="primary"
        text
        @click="downloadFile('getcsvidentificacaooperadoraautorizador', filterData)"
        :disabled="list.length == 0"
      >
        <v-icon small class="pr-2">fa-download</v-icon>
        Exportar resultado
      </v-btn>
    </v-col>
    <v-data-table
      dense
      :headers="headers"
      :items="list"
      hide-default-footer
      min="-1"
      max="15"
      class="indent-operadora-table"
      :items-per-page="total_pages"
      :page.sync="page"
      @page-count="pageCount = parseInt($event, 10)"
    >
      <template v-slot:item.prest_nome="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="pr-1">
              <v-icon :color="item.login_valido ? 'success' : 'error'" small>
                {{
                  item.login_valido
                    ? "fas fa-check-circle"
                    : "fas fa-exclamation-circle"
                }}
              </v-icon>
            </span>
          </template>
          <span
            class="px-3 py-1 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
          >
            {{ item.login_valido ? "Válido" : "Inválido" }}
          </span>
        </v-tooltip>
        {{ item.prest_nome }}
      </template>
      <template v-slot:item.data_falha="{ item }">
        <span v-if="item.data_falha && item.data_falha != '0001-01-01T00:00:00'">
          {{ item.data_falha | formatDate }}
        </span>
      </template>
      <template v-slot:item.last_update_config="{ item }">
        <span v-if="item.last_update_config && item.last_update_config != '0001-01-01T00:00:00'">
          {{ item.last_update_config | formatDate }}
        </span>
      </template>
      <template v-slot:item.WEB_LP="{ item }">
        <span v-if="item.id != id_list">{{ mascara(item.WEB_LP) }}</span>
        <span v-if="item.id == id_list && showPassword">{{ item.WEB_LP }}</span>
        <v-text-field
          v-if="item.id == id_list && !showPassword"
          v-model="item.WEB_LP"
          outlined
          dense
          style="font-size: 12px; height: 30px"
        ></v-text-field>
      </template>
      <template v-slot:item.WEB_IU="{ item }">
        <span v-if="item.id != id_list || (item.id == id_list && showPassword)">{{ item.WEB_IU }}</span>
        <v-text-field
          v-if="item.id == id_list  && !showPassword"
          v-model="item.WEB_IU"
          outlined
          dense
          style="font-size: 12px; height: 30px"
        ></v-text-field>
      </template>
      <template v-slot:item.acoes="{ item }">
        <span style="min-width: 120px">
          <v-tooltip
            v-if="
              item.id != id_list &&
              !userData.PermissaoAcoes.portal.includes(
                'updateidentoperautorizador'
              )
            "
            center
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="rgb(151 151 151 / 58%)"
                v-bind="attrs"
                v-on="on"
                x-small
                icon
              >
                <v-icon x-small>fa-pencil-alt</v-icon>
              </v-btn>
            </template>
            <span
              class="px-3 py-1 ma-0"
              style="
                border: solid 1px #999;
                border-radius: 5px;
                background-color: #fff;
              "
            >
              Você não possui permissão para executar esta ação.
            </span>
          </v-tooltip>
          <v-btn
            x-small
            v-if="
              (item.id != id_list ||( item.id == id_list && showPassword)) &&
              userData.PermissaoAcoes.portal.includes(
                'updateidentoperautorizador'
              )
            "
            @click="editItem(item.id) "
            icon
            
          >
            <v-icon x-small color="primary">fa-pencil-alt</v-icon>
          </v-btn>
          <v-btn x-small v-if="item.id == id_list && !showPassword" @click="saveEdit(item)" icon>
            <v-icon x-small color="primary">fa-check</v-icon>
          </v-btn>
          <v-btn x-small v-if="item.id != id_list ||(item.id == id_list && !showPassword)" @click="showItem(item.id)" icon>
            <v-icon x-small color="primary">fa-eye</v-icon>
          </v-btn>
          <v-btn x-small v-if="item.id == id_list && showPassword" @click="showPassword=false; id_list = null" icon>
            <v-icon x-small color="primary">fa-eye-slash</v-icon>
          </v-btn>
          <v-btn x-small @click="showOpen(item)" icon>
            <v-icon x-small color="primary">fa-history</v-icon>
          </v-btn>

          <!-- <v-btn v-if="item.id != id_list" x-small @click="showOpen(item)" icon>
              <v-icon x-small color="primary">fa-eye</v-icon>
            </v-btn>
            <v-btn v-else icon x-small color="error" @click="id_list = null">
              <v-icon>mdi-close</v-icon>
            </v-btn> -->
        </span>
      </template>
    </v-data-table>
    <v-col class="text-center" cols="12">
      <v-pagination
        class="no-box-shadow"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </v-col>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      headers: [
        {
          text: "Prestador",
          align: "left",
          value: "prest_nome",
          sortable: false,
        },
        {
          text: "Ident. na Oper.",
          value: "identificador_prestador",
          sortable: false,
        },
        { text: "Operadora", value: "oper_nome", sortable: false },
        { text: "Descrição", value: "descricao", sortable: false },
        {
          text: "Falha",
          value: "data_falha",
          align: "center",
          sortable: false,
        },
        {
          text: "Atualização",
          value: "last_update_config",
          align: "center",
          sortable: false,
        },
        { text: "Login", value: "WEB_LU", sortable: false },
        { text: "Senha", value: "WEB_LP", sortable: false },
        { text: "Outros", value: "WEB_IU", sortable: false },
        { text: "Ações", value: "acoes", align: "center", sortable: false },
      ],
      id_list: null,
      prestadoresFilter: [],
      page: 1,
      pageCount: 1,
      showPassword: false,
      total_pages: 10,
    };
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
  },
  watch:{
    list:{
      deep: true,
      handler(val){
        if (val){
          this.page = 1
        }
      }
    }
  },
  methods: {
    downloadFile(acao, filterData) {
      let modulo = "Portal" 
      let Payload = {...filterData}
      this.$store.dispatch("documents/getDocumentPost", { Payload, acao, modulo }, {root:true})
    },
    editItem(id) {
      this.id_list = id;
      this.showPassword = false;
    },
    showItem(id){
      this.id_list = id;
      this.showPassword = true;
    },
    mascara(senha){
      return this.$store.getters["common/senhaMask"](senha)
    },
    saveEdit(item) {
      this.id_list = null;
      this.sendEdit(item);
    },
    getModulos(){
      return this.$store.getters["permissions/getModulosList"]
    }
  },
  props: {
    filterData: Object,
    list: Array,
    pagination: Object,
    userData: Object,
    getList: Function,
    sendEdit: Function,
    showOpen: Function,
  },
};
</script>

<style>
.no-box-shadow,
.no-box-shadow * {
  box-shadow: 0 0 0 0 !important;
}
.theme--light.v-data-table.indent-operadora-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child,
.theme--light.v-data-table.indent-operadora-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  min-width: 75px;
  padding-left: 2px;
  padding-right: 2px;
}
</style>
